module.exports = __webpack_public_path__ + "static/media/kaserne-t1.b39928f0.svg";